module.exports = __webpack_public_path__ + "assets/fonts/favicon.b0af7b8.ico";